import type { Theme } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import type { AppFonts } from '../../entries/AppFonts';

export function createAppTheme(fonts: AppFonts): Theme {
  return createTheme({
    components: {
      MuiModal: {
        defaultProps: {
          classes: {
            root: fonts.className,
          },
        },
      },
      MuiDrawer: {
        defaultProps: {
          classes: {
            root: fonts.className,
          },
        },
      },
    },
  });
}
